import React, { useState, useEffect } from 'react';
import { Input, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import style from './SearchField.module.scss';

interface ISearchField {
	changeSearchString: (value: string) => void;
	searchString: string;
}

const SearchField: React.FC<ISearchField> = ({ searchString, changeSearchString }) => {
	const [value, setValue] = useState<string>('');
	const { t } = useTranslation('global');

	useEffect(() => {
		const timeoutID = setTimeout(() => {
			changeSearchString(value);
		}, 800);
		return () => {
			return clearTimeout(timeoutID);
		};
	}, [value]);

	useEffect(() => {
		if (searchString !== value) {
			setValue(searchString);
		}
	}, [searchString]);

	return (
		<Input
			className={style.searchInput}
			onChange={(e) => setValue(e.target.value)}
			value={value}
			placeholder={t('searchPlaceholder')}
			allowClear={true}
			suffix={
				<Tooltip title={t('searchPlaceholder')}>
					<SearchOutlined className={style.searchIcon} />
				</Tooltip>
			}
		/>
	);
};

export default React.memo(SearchField);
